import { render, staticRenderFns } from "./OrderDraftItemVariants.vue?vue&type=template&id=3bfcee2e&"
import script from "./OrderDraftItemVariants.vue?vue&type=script&lang=js&"
export * from "./OrderDraftItemVariants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports